import { createFileRoute } from "@tanstack/react-router";
import About from "@/pages/About";
import { aboutHead } from "@/lib/route-seo";

export const Route = createFileRoute("/about/")({
  head: () => aboutHead(),
  component: About,
});
